export default __webpack_public_path__ + "portfolio04.jpg";